export const MINIMAL_NUMBER_OF_EXAMPLES_FOR_SAVE_AS_LBE = 20
export const DATABASE_TIME_ZONE = 'en-GB'
